/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const MODULE_NAME = 'app.core/modules/dismiss';
const log = debug(MODULE_NAME);
const ELEMENT_ATTRIBUTE = 'data-dismiss';


class DismissPlugin {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.dismissTarget = this.$element.attr(ELEMENT_ATTRIBUTE);
        this.$dismissElement = $(this.dismissTarget);

        log('DismissPlugin', element);
        this.watch();
    }

    onClick () {
        log('clicked', this.$element);
        this.dismissTargetElement();
    }

    watch () {
        this.$element.on('click', this.onClick.bind(this));
    }

    unwatch () {
        this.$element.off('click', this.onClick);
        log('unbound', this.$element);
    }

    dismissTargetElement () {
        this.$dismissElement.fadeOut();
    }

}

DismissPlugin.DEFAULTS = {
};


plugin('dismiss', DismissPlugin);

export function exec () {
    $(document).ready(() => {
        log('binding');
        $("[data-dismiss]").dismiss();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/dismiss/index.js